import React, { Children } from 'react';

import {
  string,
  func,
  shape,
  bool,
  node,
  oneOfType,
  arrayOf
} from 'prop-types';

import { Modal as AntdModal } from 'antd';

import ClassNames from 'classnames';

import BaseComponent from '../.internal/BaseComponent';
import Icon from '../icon/Icon';

import 'antd/lib/modal/style/index.css';
import './Modal.scss';

export default class Modal extends BaseComponent {
  render() {
    const {
      visible,
      iconClosable,
      maskClosable,
      loading,
      style,
      maskStyle,
      id,
      className,
      onClose,
      children
    } = this.props;

    const classNames = ClassNames(['Modal', className]);

    const ModalChildren = {
      ModalBody: undefined,
      ModalHeader: undefined,
      ModalActions: null
    };

    Children.forEach(children, element => {
      switch (element.props.type) {
        case 'body':
          ModalChildren.ModalBody = element;
          break;
        case 'header':
          ModalChildren.ModalHeader = (
            <h3 className="Modal__heading">{element}</h3>
          );
          break;
        case 'actions':
          ModalChildren.ModalActions = element;
          break;
        default:
          break;
      }
    });

    const modalHeader = ModalChildren.ModalHeader && ModalChildren.ModalHeader;
    const modalBody = ModalChildren.ModalBody && ModalChildren.ModalBody;
    const modalActions =
      ModalChildren.ModalActions && ModalChildren.ModalActions;

    return (
      <AntdModal
        closeIcon={<Icon icon="times" />}
        footer={modalActions}
        closable={iconClosable}
        id={id}
        loading={loading}
        maskClosable={maskClosable}
        maskStyle={maskStyle}
        onCancel={onClose}
        style={style}
        title={modalHeader}
        visible={visible}
        wrapClassName={classNames}
      >
        {modalBody}
      </AntdModal>
    );
  }
}

Modal.propTypes = {
  visible: bool,
  iconClosable: bool,
  maskClosable: bool,
  loading: bool,
  maskStyle: shape({}),
  style: shape({}),
  id: string,
  className: string,
  onClose: func,
  children: oneOfType([arrayOf(node), node]).isRequired
};

Modal.defaultProps = {
  visible: false,
  iconClosable: true,
  maskClosable: true,
  loading: false,
  maskStyle: {},
  style: {},
  id: undefined,
  className: undefined
};
